import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentTrackFilterEntity } from '../../domain/entities/ShipmentTrackFilterEntity'
import { ShipmentStatus } from '@/features/shipment/domain/enums/ShipmentStatus'

export class ShipmentTrackFilterModel extends ShipmentTrackFilterEntity {
  regionIds!: number[]
  channelIds!: number[]
  constructor(dataDto: ShipmentTrackFilterEntity) {
    super()
    mapEntityProperties<ShipmentTrackFilterModel>(this, dataDto, {
      map: {
        regionIds: dataDto.regions?.map((region) => region.id),
        channelIds: dataDto.channels?.map((channel) => channel.id),
        shipmentStatuses: [
          ShipmentStatus.ACQUIRED,
          ShipmentStatus.DRIVER_REACHED_BRANCH,
          ShipmentStatus.PICKED_UP,
          ShipmentStatus.DELIVERING,
          ShipmentStatus.AT_DESTINATION,
          ShipmentStatus.COMPLETED,
          ShipmentStatus.REJECTED,
          ShipmentStatus.CANCELED
        ]
      }
    })
  }
}
